import type * as Core from "@zeller-public/payments-sdk-core";

import { never } from "../shared/never";
import TerminalGetTransactions from "./routes/terminal-get-transactions";
import TerminalInitialise from "./routes/terminal-initialise";
import TerminalPurchase from "./routes/terminal-purchase";
import TerminalRefund from "./routes/terminal-refund";
import TerminalSetup from "./routes/terminal-setup";

export namespace Routes {
	export type Props = {
		request: Core.Protocol.Request_Query;
	};
}

export function Routes(props: Routes.Props) {
	const {
		request: { headers, query },
	} = props;
	switch (query.$type) {
		case "Terminal_initialise":
			return <TerminalInitialise headers={headers} query={query} />;
		case "Terminal_setup":
			return <TerminalSetup headers={headers} query={query} />;
		case "Terminal_purchase":
			return <TerminalPurchase headers={headers} query={query} />;
		case "Terminal_refund":
			return <TerminalRefund headers={headers} query={query} />;
		case "Terminal_getTransactions":
			return <TerminalGetTransactions headers={headers} query={query} />;
		/* v8 ignore next 2 -- exhaustiveness guard, unreachable for valid queries */
		default:
			return never(query);
	}
}
